import type {FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions, Timestamp,} from 'firebase/firestore'

export const liveEventConverter: FirestoreDataConverter<LiveEvent> = {
    fromFirestore: (
        snapshot: QueryDocumentSnapshot<LiveEvent>,
        options: SnapshotOptions,
    ): LiveEvent => {
        const data = snapshot.data(options)

        return { id: snapshot.id, ...data } as LiveEvent // Adjust this mapping as necessary
    },
    toFirestore: (modelObject: LiveEvent): LiveEventDocument => {
        const { id, ...liveEvent } = modelObject
        return { ...liveEvent }
    },
}

export type LiveEventDocument = {
    name: string
    startDate: Timestamp
    endDate: Timestamp
    previewDate?: Timestamp
}

export type LiveEvent = LiveEventDocument & {
    id: string
}

export type PlayEvent = LiveEvent & {
    assets: {
        bannerLogo: string
        leaderboardHeader: string
        loadingSplash: string
        playImageUrl: string
    }
    branding: {
        backgroundColor: string
        primaryColor: string
    }
    description: string
    layoutIds: string[]
}

